import { render, staticRenderFns } from "./BaseChannelPieChartOwnedEarned.vue?vue&type=template&id=4d90982e&"
import script from "./BaseChannelPieChartOwnedEarned.vue?vue&type=script&lang=js&"
export * from "./BaseChannelPieChartOwnedEarned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports